module.exports = __webpack_public_path__ + "img/award (3).7893253f.jpg";